
document.addEventListener("DOMContentLoaded", () => {

  // ---- LOADER ----
  const loader = document.getElementById("loader");
  setTimeout(() => {
    loader.classList.add("done");
    document.body.classList.remove("loading");
    setTimeout(() => loader.remove(), 700);
  }, 1800);

  // ---- CUSTOM CURSOR ----
  const cursor = document.getElementById("cursor");
  const trail = document.getElementById("cursor-trail");
  let mx = 0, my = 0, tx = 0, ty = 0;
  document.addEventListener("mousemove", e => { mx = e.clientX; my = e.clientY; cursor.style.left = mx+"px"; cursor.style.top = my+"px"; });
  function animTrail() { tx += (mx - tx) * 0.12; ty += (my - ty) * 0.12; trail.style.left = tx+"px"; trail.style.top = ty+"px"; requestAnimationFrame(animTrail); }
  animTrail();
  document.querySelectorAll(".magnetic, .btn, a, .cat-card, .product-card").forEach(el => {
    el.addEventListener("mouseenter", () => { cursor.style.width="28px"; cursor.style.height="28px"; trail.style.width="60px"; trail.style.height="60px"; });
    el.addEventListener("mouseleave", () => { cursor.style.width="14px"; cursor.style.height="14px"; trail.style.width="36px"; trail.style.height="36px"; });
  });

  // ---- PARTICLE CANVAS ----
  const canvas = document.getElementById("particle-canvas");
  if (canvas) {
    const ctx = canvas.getContext("2d");
    canvas.width = window.innerWidth; canvas.height = window.innerHeight;
    window.addEventListener("resize", () => { canvas.width = window.innerWidth; canvas.height = window.innerHeight; });
    const particles = Array.from({length: 80}, () => ({
      x: Math.random() * canvas.width, y: Math.random() * canvas.height,
      vx: (Math.random()-0.5)*0.4, vy: (Math.random()-0.5)*0.4,
      r: Math.random()*2+0.5, opacity: Math.random()*0.4+0.1
    }));
    function drawParticles() {
      ctx.clearRect(0,0,canvas.width,canvas.height);
      particles.forEach(p => {
        p.x += p.vx; p.y += p.vy;
        if (p.x<0) p.x=canvas.width; if (p.x>canvas.width) p.x=0;
        if (p.y<0) p.y=canvas.height; if (p.y>canvas.height) p.y=0;
        ctx.beginPath(); ctx.arc(p.x,p.y,p.r,0,Math.PI*2);
        ctx.fillStyle = `rgba(255,255,255,${p.opacity})`; ctx.fill();
      });
      particles.forEach((p,i) => {
        for (let j=i+1; j<particles.length; j++) {
          const d = Math.hypot(p.x-particles[j].x, p.y-particles[j].y);
          if (d<100) { ctx.beginPath(); ctx.moveTo(p.x,p.y); ctx.lineTo(particles[j].x,particles[j].y); ctx.strokeStyle=`rgba(255,255,255,${0.06*(1-d/100)})`; ctx.lineWidth=0.5; ctx.stroke(); }
        }
      });
      requestAnimationFrame(drawParticles);
    }
    drawParticles();
  }

  // ---- TYPEWRITER ----
  const tw = document.getElementById("typewriter");
  if (tw) {
    const texts = ["verdient das Beste.", "liebt Premium.", "ist dein Herz."];
    let ti = 0, ci = 0, deleting = false;
    function type() {
      const current = texts[ti];
      if (!deleting) { tw.textContent = current.substring(0, ++ci); if (ci===current.length) { deleting=true; setTimeout(type,2000); return; } }
      else { tw.textContent = current.substring(0, --ci); if (ci===0) { deleting=false; ti=(ti+1)%texts.length; } }
      setTimeout(type, deleting ? 50 : 90);
    }
    setTimeout(type, 1200);
  }

  // ---- COUNTERS ----
  function animateCounter(el) {
    const target = parseInt(el.dataset.target);
    let current = 0;
    const step = target / 60;
    const interval = setInterval(() => {
      current = Math.min(current + step, target);
      el.textContent = Math.floor(current);
      if (current >= target) clearInterval(interval);
    }, 25);
  }

  // ---- SCROLL REVEAL ----
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-visible");
        entry.target.querySelectorAll(".highlight-word::after").forEach(el => el.style.transform="scaleX(1)");
        entry.target.querySelectorAll(".counter").forEach(animateCounter);
      }
    });
  }, { threshold: 0.12 });

  document.querySelectorAll(".reveal-card, .reveal-split, .reveal-left, .reveal-right, .reveal-scale").forEach(el => observer.observe(el));

  // ---- NAVBAR SCROLL ----
  const navbar = document.querySelector(".navbar");
  window.addEventListener("scroll", () => {
    if (window.scrollY > 80) navbar.classList.add("scrolled");
    else navbar.classList.remove("scrolled");
  });
  navbar.classList.add("scrolled");

  // ---- 3D TILT CARDS ----
  document.querySelectorAll(".tilt-card").forEach(card => {
    card.addEventListener("mousemove", e => {
      const r = card.getBoundingClientRect();
      const x = e.clientX - r.left - r.width/2;
      const y = e.clientY - r.top - r.height/2;
      card.style.transform = `translateY(-12px) scale(1.02) rotateX(${-y/18}deg) rotateY(${x/18}deg)`;
    });
    card.addEventListener("mouseleave", () => { card.style.transform = ""; });
  });

  // ---- HIGHLIGHT WORD trigger ----
  document.querySelectorAll(".highlight-word").forEach(el => el.classList.add("active"));
});
